<h1 mat-dialog-title>
  {{title}}
</h1>

<div mat-dialog-content>
  <p class="confirmation-message">{{message}}</p>

  <div *ngIf="details" class="details-container">
    <ng-container *ngFor="let detail of details">
      <span class="detail-label">{{ detail.label }}</span>
      <span class="detail-value">{{ detail.value }}</span>
    </ng-container>
  </div>
</div>

<div mat-dialog-actions align="center">
  <button mat-button (click)="onDismiss()">{{cancel}}</button>
  <button mat-button (click)="onConfirm()">{{confirm}}</button>
</div>
